import script from "./AppleLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppleLogin.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__